import "./Preloader.scss";
import logo from "../../assets/aqui.png";

export default function Preloader({ show, text = "Carregando dados..." ,customClass = ""}) {
  return (
    <div
     className={`loader-overlay ${customClass}`}
      style={{
        opacity: show ? 1 : 0,
        pointerEvents: show ? "all" : "none",
        transition: "opacity 0.5s ease 0.5s", // delay de 1s
    
      }}
    >
      <div className="global-signal"></div>

      <div className="loader-box">
        <div className="ring"></div>

        <span className="signal s1"></span>
        <span className="signal s2"></span>
        <span className="signal s3"></span>

        <img src={logo} alt="Inova" className="loader-logo" />
      </div>

      <span className="loader-text">
        {text.split("").map((char, index) => (
          <span
            key={index}
            className="loader-letter"
            style={{ animationDelay: `${index * 0.05}s` }}
          >
            {char === " " ? "\u00A0" : char}
          </span>
        ))}
      </span>
    </div>
  );
}
